import {Component, OnInit, OnChanges} from '@angular/core';
import {AuthControllerService} from "../../../services/auth-controller/auth-controller.service";
import { SharedModule } from 'app/shared.module';
import { AppWidgetModule } from 'app/components/widgets/widget.module';

@Component({
    selector: 'login-page',
    templateUrl: `./dashboard.component.html`,
    standalone: true,
    imports: [SharedModule, AppWidgetModule]
})
export class DashboardPage implements OnInit, OnChanges {
    currentUserIsAdmin: boolean;
    currentUserIsAnalyst: boolean;
	currentUserIsInstitutionManager: boolean;

    constructor(private authService: AuthControllerService) {
    }

    ngOnInit(): void {
        this.bindRoles = this.bindRoles.bind(this);
        this.authService.subscribeForTokenChange(this.bindRoles);
		this.bindRoles();
    }

    ngOnChanges(){
        this.ngOnInit();
    }

	ngOnDestroy(): void {
		this.authService.unsubscribe(this.bindRoles);
	}

    private bindRoles() {
        this.currentUserIsAdmin = this.authService.resolveRole('sysadmin');
        this.currentUserIsAnalyst = this.authService.resolveRole('stat_analyst');
		this.currentUserIsInstitutionManager = this.authService.resolveRole('superinspector');
    }
}
